import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import type { WebhookEventSubscription } from '../typescript-types/webhook-event-subscriptions/webhook-event-subscription';

import { addNotificationAction } from '../action/notifications/notifications';

import * as Api from '../api/api';
import { UiButton } from '../ui/ui-button';

import { subscriberTypeDisplayName } from './utils/webhook-event-subscription-utils';
import { confirm } from '../widgets/confirmation-dialog';

type InputProps = {
  webhookEventSubscription: WebhookEventSubscription | null;
};

export const WebhookEventTestButton = (props: InputProps) => {
  const { webhookEventSubscription } = props;
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  if (!webhookEventSubscription) {
    return null;
  }

  const handlePostEvent = async () => {
    const { webhookEventSubscriptionId, subscriberType } = webhookEventSubscription;

    if (await confirm('Are you sure you want to post a test event for this connection now?')) {
      setIsLoading(true);
      Api.post(`/webhook-event-subscription/${webhookEventSubscriptionId}/send-test-event`).then(
        () => {
          dispatch(
            addNotificationAction({
              key: `post-test-${subscriberTypeDisplayName(subscriberType)}-event`,
              message: `Successfully queued test ${subscriberTypeDisplayName(
                subscriberType,
              )} event. Event may take several minutes to complete processing from the queue.`,
            }),
          );
          setIsLoading(false);
        },
      );
    }
  };

  return (
    <UiButton size="xs" variant="tertiary" onClick={handlePostEvent} loading={isLoading}>
      Send Test Event
    </UiButton>
  );
};
